export default __webpack_public_path__ + "static/media/P344_RoHS.9562a444.pdf";